<template>
  <div>
    <el-card class="page-container">
      <el-row class="search">
        <span>物品类型：</span>
        <el-select filterable v-model="search.itemType" placeholder="">
          <el-option
            v-for="(item, itemIndex) in typelist"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span> 是否有效：</span
        ><el-select filterable v-model="search.valid" placeholder="">
          <el-option label="有效" :value="1"></el-option>
          <el-option label="无效" :value="0"></el-option>
        </el-select>
        <span>应用场景：</span
        ><el-select filterable clearable v-model="search.access" placeholder="">
          <el-option
            v-for="(item, itemIndex) in accesslist"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span> 物品名：</span>
        <el-input
          type="text"
          v-model="search.itemName"
          placeholder="请输入物品名"
        ></el-input>
        <span> 物品ID：</span>
        <el-input
          type="text"
          v-model="search.itemId"
          placeholder="请输入物品ID"
        ></el-input>
        <el-button type="primary" @click="query" :loading="loading">
          查询
        </el-button>
        <el-button type="warning" @click="operate(1)"> 新增 </el-button>
      </el-row>
      <el-row>
        <el-button type="info" v-if="isText === 1" @click="dialogVisible = true"
          >导入</el-button
        >
      </el-row>
      <el-dialog :visible.sync="dialogVisible">
        <el-input
          type="textarea"
          :rows="5"
          autosize
          placeholder="请输入内容"
          v-model="textarea"
        >
        </el-input>
        <el-button @click="copyData">确认</el-button>
      </el-dialog>
      <el-row>
        <el-table
          :data="datalist"
          style="width: 100%"
          v-loading="loading"
          height="60vh"
          stripe
          border
        >
          <el-table-column prop="itemId" label="装扮ID"> </el-table-column>
          <el-table-column label="应用场景">
            <template slot-scope="scope">
              {{
                accesslist.filter((x) => x.value == scope.row.access)[0].label
              }}
            </template>
          </el-table-column>
          <el-table-column label="装扮图片">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: auto"
                :src="scope.row.iconUrl"
                :preview-src-list="[scope.row.iconUrl]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="装扮名称"> </el-table-column>
          <el-table-column prop="itemDesc" label="装扮描述"> </el-table-column>
          <el-table-column prop="itemType" label="装扮类型">
            <template slot-scope="scope">
              {{
                typelist.filter((x) => x.value == scope.row.itemType)[0].label
              }}
            </template>
          </el-table-column>
          <el-table-column prop="valid" label="状态">
            <template slot-scope="scope">
              {{ scope.row.valid == 1 ? '有效' : '无效' }}
            </template>
          </el-table-column>
          <el-table-column prop="len" label="动画时间"> </el-table-column>
          <el-table-column prop="orderId" label="排序"> </el-table-column>
          <el-table-column label="价格列表" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="operatePrice(1, scope.row)"
                >查看</el-button
              >
            </template></el-table-column
          >
          <el-table-column prop="bossLevel" label="boss等级"> </el-table-column>
          <el-table-column prop="createDate" label="创建时间">
          </el-table-column>
          <el-table-column prop="operator" label="操作人"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="operate(2, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="primary"
                size="mini"
                id="btn"
                @click="copy(scope.row)"
                >复制到测试服</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </el-row>
      <el-row>
        <el-pagination
          :current-page.sync="pageInfo.page"
          layout="total, prev, pager, next"
          background
          @current-change="handleCurrentChange"
          :total="pageInfo.total"
          class="pagination"
          :page-size="30"
        ></el-pagination>
      </el-row>
    </el-card>
    <el-drawer
      :title="type === 2 ? '编辑' : '新增'"
      size="40%"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="item" v-if="type == 1">
        <span>装扮类型：</span
        ><el-select filterable v-model="data.itemType" placeholder="">
          <el-option
            v-for="(item, itemIndex) in typelist"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item" v-if="type == 1">
        <span>应用场景：</span
        ><el-select filterable v-model="data.access" placeholder="">
          <el-option
            v-for="(item, itemIndex) in accesslist.slice(1)"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>融合资源url：</span>
        <el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(6, value)"
          ref="upload"
        >
          <el-image
            v-if="data.fusionUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.fusionUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>融合开关：</span
        ><el-switch
          v-model="data.fusionSwitch"
          active-text="开启"
          inactive-text="关闭"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="item">
        <span>id色值：</span><el-input type="text" v-model="data.idColor" />
      </div>
      <div class="item">
        <span>昵称色值：</span><el-input type="text" v-model="data.nameColor" />
      </div>
      <div class="item">
        <span>昵称开关：</span
        ><el-switch
          v-model="data.fusionNameSwitch"
          active-text="开启"
          inactive-text="关闭"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="item">
        <span>id开关：</span
        ><el-switch
          v-model="data.fusionIdSwitch"
          active-text="开启"
          inactive-text="关闭"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="item">
        <span>装扮名称：</span><el-input type="text" v-model="data.itemName" />
      </div>
      <div class="item" v-if="type == 1">
        <span>装扮描述：</span><el-input type="text" v-model="data.itemDesc" />
      </div>
      <div class="item">
        <span>排序值：</span><el-input type="number" v-model="data.orderId" />
      </div>
      <div
        class="item"
        v-if="
          data.access == 3 ||
          data.access == 5 ||
          data.itemType == 8 ||
          data.access == 7 ||
          data.access == 9 ||
          data.access == 11 ||
          data.itemType == 11
        "
      >
        <span>等级：</span><el-input type="number" v-model="data.bossLevel" />
      </div>
      <div class="item">
        <span>装扮图片：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(1, value)"
          ref="upload"
        >
          <el-image
            v-if="data.iconUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.iconUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>装扮资源：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(2, value)"
          ref="upload"
        >
          <el-image
            v-if="data.resourceUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.resourceUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>装扮动画：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(3, value)"
          ref="upload"
        >
          <el-image
            v-if="data.originUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.originUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>装扮动画2：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(5, value)"
          ref="upload"
        >
          <el-image
            v-if="data.originAddUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.originAddUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>装扮动画3：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(7, value)"
          ref="upload"
        >
          <el-image
            v-if="data.originExternalUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.originExternalUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>装扮动画4：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(8, value)"
          ref="upload"
        >
          <el-image
            v-if="data.originExpandUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.originExpandUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>展示图标：</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="(value) => changfile(4, value)"
          ref="upload"
        >
          <el-image
            v-if="data.showUrl !== ''"
            style="width: auto; height: 178px"
            :src="data.showUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>动画时间：</span><el-input type="number" v-model="data.len" />
      </div>
      <div class="item">
        <span>状态：</span
        ><el-switch
          v-model="data.valid"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="有效"
          inactive-text="无效"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </div>
      <div class="item item1" v-if="type == 1">
        <el-table :data="data.priceList" style="width: 100%" stripe border>
          <el-table-column prop="price" label="价格"> </el-table-column>
          <el-table-column prop="purchaseTime" label="天数"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="operatePriceLocal(2, scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <span>价格：</span>
          <el-input
            type="number"
            placeholder="请输入价格"
            v-model="pricelocal.price"
          />
          <span>天数：</span>
          <el-input
            type="number"
            placeholder="请输入天数"
            v-model="pricelocal.purchaseTime"
          />
          <el-button type="warning" @click="operatePriceLocal(1)">
            新增
          </el-button>
        </div>
      </div>

      <div class="item">
        <el-button type="primary" @click="operate(3)" v-if="type == 1"
          >新增</el-button
        >
        <el-button type="primary" @click="operate(4)" v-if="type == 2"
          >编辑</el-button
        >
      </div>
    </el-drawer>
    <el-dialog
      title="价格配置详情"
      :visible.sync="dialog"
      width="70%"
      :before-close="handleClose1"
    >
      <el-row class="search">
        <span>价格：</span>
        <el-input
          type="text"
          placeholder="请输入价格"
          v-model="priceData.price"
        />
        <span>天数：</span>
        <el-input
          type="text"
          placeholder="请输入天数"
          v-model="priceData.purchaseTime"
        />
        <el-button type="warning" @click="operatePrice(2)"> 新增 </el-button>
      </el-row>
      <el-row>
        <el-table
          :data="pricelist"
          style="width: 100%"
          v-loading="loading"
          height="60vh"
          stripe
          border
        >
          <el-table-column prop="price" label="价格"> </el-table-column>
          <el-table-column prop="purchaseTime" label="天数"> </el-table-column>
          <el-table-column prop="operator" label="创建人"> </el-table-column>
          <el-table-column prop="createDate" label="创建时间">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="operatePrice(3, scope.row)"
                >删除</el-button
              >
            </template></el-table-column
          >
        </el-table>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { type } from '@/store/index.js'
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      dialogVisible: false,
      isText: type,
      typelist: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '座位框',
          value: 1,
        },
        {
          label: '气泡框',
          value: 2,
        },
        {
          label: '座驾',
          value: 3,
        },
        {
          label: '进场特效',
          value: 4,
        },
        {
          label: '称号',
          value: 8,
        },
        {
          label: '主播守护勋章',
          value: 9,
        },
        {
          label: '资料卡',
          value: 10,
        },
        {
          label: '成就称号',
          value: 11,
        },
        {
          label: '彩色id',
          value: 12,
        },
        {
          label: '连麦边框',
          value: 13,
        },
        {
          label: '连麦音效',
          value: 14,
        },
        {
          label: '彩色昵称',
          value: 15,
        },
        {
          label: '个人主页飘萍',
          value: 16,
        },
      ],
      accesslist: [
        {
          label: '全部',
          value: null,
        },
        {
          label: '商城',
          value: 1,
        },
        {
          label: '活动',
          value: 2,
        },
        {
          label: 'boss等级',
          value: 3,
        },
        {
          label: '贵族等级',
          value: 5,
        },
        {
          label: 'VIP',
          value: 6,
        },
        {
          label: '主播守护',
          value: 7,
        },
      ],
      textarea: '',
      search: {
        itemType: null,
        valid: 1,
        itemName: '',
        itemId: '',
        access: null,
      },
      pageInfo: {
        page: 1,
        total: 0,
      },
      loading: false,
      loading1: false,
      drawer: false,
      dialog: false,
      dialogPrice: false,
      dwnload: false,
      datalist: [],
      type: 1,
      data: {
        itemType: null,
        access: '',
        itemName: '',
        itemDesc: '',
        orderId: '',
        bossLevel: '',
        iconUrl: '',
        resourceUrl: '',
        originUrl: '',
        originAddUrl: '',
        originExternalUrl: '',
        originExpandUrl: '',
        showUrl: '',
        len: '',
        valid: '',
        priceList: [],
        fusionUrl: '',
        fusionSwitch: 0,
        idColor: '',
        nameColor: '',
        fusionIdSwitch: 0,
        fusionNameSwitch: 0,
      },
      pricelist: [],
      itemId: '',
      priceData: {
        price: 0,
        purchaseTime: 0,
      },
      pricelocal: {
        price: 0,
        purchaseTime: 0,
      },
    }
  },
  methods: {
    async query() {
      this.loading = true
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.config_roomItems_query +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        withCredentials: true,
        params: {
          valid: this.search.valid,
          access: this.search.access,
          itemType: this.search.itemType,
          itemName: this.search.itemName,
          itemId: this.search.itemId,
          page: this.pageInfo.page,
        },
      })
      console.log(res.data.data)
      this.loading = false
      if (res.code != 0) return this.$message.error(res.msg)
      this.datalist = res.data.data
      this.pageInfo.total = res.data.total

      this.$message.success('查询成功')
    },
    async getAccess() {
      const { data: res } = await this.$axios({
        method: 'get',
        url:
          this.$store.getters.path.config_roomItems_getAccess +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        params: {
          className: 'com.quhong.constant.RoomItemAccessConstant',
        },
        withCredentials: true,
      })
      if (res.code != 0) return this.$message.error(res.msg)
      console.log(res.data)
      this.accesslist = [
        {
          label: '全部',
          value: null,
        },
        ...res.data.map((item) => {
          return {
            value: item.value,
            label: item.name,
          }
        }),
      ]
    },
    async operate(type, obj) {
      if (type == 1) {
        this.type = type
        this.drawer = true
      } else if (type == 2) {
        this.type = type
        this.drawer = true
        console.log(obj)
        this.data = {
          itemId: obj.itemId,
          itemType: obj.itemType,
          access: obj.access,
          itemName: obj.itemName,
          orderId: obj.orderId,
          iconUrl: obj.iconUrl,
          resourceUrl: obj.resourceUrl,
          originUrl: obj.originUrl,
          originAddUrl: obj.originAddUrl,
          originExternalUrl: obj.originExternalUrl,
          originExpandUrl: obj.originExpandUrl,
          showUrl: obj.showUrl,
          len: obj.len,
          valid: obj.valid,
          bossLevel: obj.bossLevel,
          fusionUrl: obj.fusionUrl || '',
          fusionSwitch: obj.fusionSwitch || 0,
          idColor: obj.idColor || '',
          nameColor: obj.nameColor || '',
          fusionIdSwitch: obj.fusionIdSwitch || 0,
          fusionNameSwitch: obj.fusionNameSwitch || 0,
        }
      } else if (type == 3) {
        const params = {
          itemType: this.data.itemType,
          access: this.data.access,
          itemName: this.data.itemName,
          itemDesc: this.data.itemDesc,
          orderId: this.data.orderId,
          iconUrl: this.data.iconUrl,
          resourceUrl: this.data.resourceUrl,
          originUrl: this.data.originUrl,
          originAddUrl: this.data.originAddUrl,
          originExternalUrl: this.data.originExternalUrl,
          originExpandUrl: this.data.originExpandUrl,
          showUrl: this.data.showUrl,
          len: this.data.len,
          valid: this.data.valid,
          priceList: this.data.priceList,
          fusionUrl: this.data.fusionUrl,
          fusionSwitch: this.data.fusionSwitch,
          idColor: this.data.idColor,
          nameColor: this.data.nameColor,
          fusionIdSwitch: this.data.fusionIdSwitch,
          fusionNameSwitch: this.data.fusionNameSwitch,
        }
        if (
          this.data.access == 3 ||
          this.data.access == 5 ||
          this.data.itemType == 8 ||
          this.data.access == 7 ||
          this.data.access == 9
        )
          params.bossLevel = this.data.bossLevel
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.config_roomItems_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          params
        )
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
        this.handleClose()
      } else if (type == 4) {
        const { data: res } = await this.$axios({
          url:
            this.$store.getters.path.config_roomItems_edit +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          withCredentials: true,
          params: {
            itemId: this.data.itemId,
            itemName: this.data.itemName,
            orderId: this.data.orderId,
            bossLevel: this.data.bossLevel,
            iconUrl: this.data.iconUrl,
            resourceUrl: this.data.resourceUrl,
            originUrl: this.data.originUrl,
            originAddUrl: this.data.originAddUrl,
            originExternalUrl: this.data.originExternalUrl,
            originExpandUrl: this.data.originExpandUrl,
            showUrl: this.data.showUrl,
            len: this.data.len,
            valid: this.data.valid,
            fusionUrl: this.data.fusionUrl,
            fusionSwitch: this.data.fusionSwitch,
            idColor: this.data.idColor,
            nameColor: this.data.nameColor,
            fusionIdSwitch: this.data.fusionIdSwitch,
            fusionNameSwitch: this.data.fusionNameSwitch,
          },
        })
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
        this.handleClose()
      }
    },
    copy(info) {
      console.log('----')
      let infos = JSON.stringify({ list: [info] })
      console.log(infos)
      let clipboard = new Clipboard('#btn', {
        text: function (trigger) {
          //返回字符串
          return infos
        },
      })
      clipboard.on('success', (e) => {
        console.log('复制成功')
        this.$message.success('复制成功')
      })
    },
    async copyData() {
      console.log(this.textarea)
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_roomItems_copy,
        data: this.textarea,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) {
        return this.$message(res.msg)
      } else {
        this.$message.success('导入成功')
        this.query()
        this.dialogVisible = false
        this.textarea = ''
      }
    },
    async operatePrice(type, obj) {
      if (type == 1) {
        this.dialog = true
        this.itemId = obj.itemId
        this.pricelist = obj.priceList
      } else if (type == 2) {
        const { data: res } = await this.$axios({
          method: 'get',
          url:
            this.$store.getters.path.config_roomItems_price_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          params: {
            itemId: this.itemId,
            ...this.priceData,
          },
        })
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
        this.handleClose1()
      } else if (type == 3) {
        const { data: res } = await this.$axios({
          url:
            this.$store.getters.path.config_roomItems_del +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token,
          withCredentials: true,
          params: {
            itemId: obj.itemId,
            skuId: obj.skuId,
          },
        })
        if (res.code != 0) return this.$message(res.msg)
        this.$message.success('操作成功')
        this.query()
        this.handleClose1()
      }
    },
    operatePriceLocal(type, ind) {
      if (type == 1) {
        if (this.pricelocal.price == 0 || this.pricelocal.purchaseTime == 0)
          return
        this.data.priceList.push({ ...this.pricelocal })
        this.pricelocal = {
          price: 0,
          purchaseTime: 0,
        }
      } else if (type == 2) {
        this.data.priceList.splice(ind, 1)
      }
    },
    async changfile(type, file) {
      this.dwnload = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      if (type == 1) {
        formdata.append('dir', 'room_item/icon/')
      } else if (type == 2) {
        formdata.append('dir', 'room_item/resource/')
      } else if (type == 3) {
        formdata.append('dir', 'room_item/origin/')
      } else if (type == 4) {
        formdata.append('dir', 'room_item/showUrl/')
      } else if (type == 5) {
        formdata.append('dir', 'room_item/originAddUrl/')
      } else if (type == 6) {
        formdata.append('dir', 'room_item/fusion/')
      } else if (type == 7) {
        formdata.append('dir', 'room_item/originExternal/')
      } else if (type == 8) {
        formdata.append('dir', 'room_item/originExpand/')
      }
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )
      this.dwnload = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      if (type == 1) {
        this.data.iconUrl = res.data
      } else if (type == 2) {
        this.data.resourceUrl = res.data
      } else if (type == 3) {
        this.data.originUrl = res.data
      } else if (type == 4) {
        this.data.showUrl = res.data
      } else if (type == 5) {
        this.data.originAddUrl = res.data
      } else if (type == 6) {
        this.data.fusionUrl = res.data
      } else if (type == 7) {
        this.data.originExternalUrl = res.data
      } else if (type == 8) {
        this.data.originExpandUrl = res.data
      }
    },
    handleClose() {
      this.drawer = false
      this.data = {
        itemType: null,
        access: '',
        itemName: '',
        itemDesc: '',
        orderId: '',
        bossLevel: '',
        iconUrl: '',
        resourceUrl: '',
        originUrl: '',
        originAddUrl: '',
        originExternalUrl: '',
        originExpandUrl: '',
        showUrl: '',
        len: '',
        valid: '',
        priceList: [],
      }
    },
    handleClose1() {
      this.dialog = false
      this.itemId = ''
      this.pricelist = []
      this.priceData = {
        price: 0,
        purchaseTime: 0,
      }
      this.query()
    },
    handleCurrentChange(num) {
      this.pageInfo.page = num
      this.query()
    },
  },

  created() {
    this.query()
    this.getAccess()
  },
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  align-items: center;

  .el-input {
    max-width: 250px;
  }

  > * {
    margin: 0 3px;
  }
}

.item {
  display: flex;
  align-items: center;
  padding: 5px 15px;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }

  &.item1 {
    flex-direction: column;

    > div:nth-child(2) {
      display: flex;
      width: 100%;
      margin-top: 10px;
      align-items: center;

      > * {
        margin: 0 2px;
      }
    }
  }
}
</style>
